import React from 'react';
import { sizes } from '@sharefiledev/antd-config';
import { Skeleton } from 'antd';
import { AppContextProvider } from '../AppContext';
import { ClientRequestListDrawerViewLoaderProps } from './ClientRequestListViewDrawer/ClientRequestListViewLoader';
import { CreateRequestListDrawerProps } from './CreateRequestListDrawer';
import { RequestListDrawerViewLoaderProps } from './CreateRequestListDrawer/RequestListDrawerViewLoader';

const LazyCreateRequestListDrawerBlock = React.lazy(
	() => import('./CreateRequestListDrawer')
);
export const AsyncCreateRequestListDrawerBlock: React.FC<
	CreateRequestListDrawerProps
> = props => {
	return (
		<React.Suspense fallback={<Skeleton active style={{ padding: sizes.MS }} />}>
			<AppContextProvider piletApi={props.piletApi}>
				<LazyCreateRequestListDrawerBlock {...props} />
			</AppContextProvider>
		</React.Suspense>
	);
};

const LazyRequestListDrawerViewLoaderBlock = React.lazy(
	() => import('./CreateRequestListDrawer/RequestListDrawerViewLoader')
);
export const AsyncRequestListDrawerViewLoaderBlock: React.FC<
	RequestListDrawerViewLoaderProps
> = props => {
	return (
		<React.Suspense fallback={<Skeleton active style={{ padding: sizes.MS }} />}>
			<LazyRequestListDrawerViewLoaderBlock {...props} />
		</React.Suspense>
	);
};

const LazyClientRequestListDrawerViewLoaderBlock = React.lazy(
	() => import('./ClientRequestListViewDrawer/ClientRequestListViewLoader')
);
export const AsyncClientRequestListDrawerViewLoaderBlock: React.FC<
	ClientRequestListDrawerViewLoaderProps
> = props => {
	return (
		<React.Suspense fallback={<Skeleton active style={{ padding: sizes.MS }} />}>
			<AppContextProvider piletApi={props.piletApi}>
				<LazyClientRequestListDrawerViewLoaderBlock {...props} />
			</AppContextProvider>
		</React.Suspense>
	);
};
